var Upload = {
    init: function() {
        this.buildHandlers();
    },

    // handlers
    buildHandlers: function() {
        var _this = this;
        $("#submitcsv").on("click", function(e) {
            $(".progress-log").removeClass("hide");
        });
        $("#call-parser").on("click", function(e) {
            e.preventDefault();
            _this.callParser();
        });
    },

    // builds all the json files from csv
    callParser: function() {
   		ParserLoadHelper.init();
   		ParserLoadHelper.loadSavedCSV();
    }
}
